import React from "react";
import { AssignmentOutlined, Inventory2Outlined, PrintOutlined, Settings, TranslateOutlined } from "@mui/icons-material";

import { MenuRoute } from "./toolympus/components/frame";
import { SystemSubmenu } from "./toolympus/components/Contests/SystemSubmenu";
import { CMS } from "./components/CMS";
import { LocalizedMessagesX } from "./components/LocalizedMessages";
import { Forms } from "./components/Forms/Forms";
import { ProductListPage, ProductEditPage } from "./components/PaymentForm/Products";
import { DiscountCodesListPage } from "./components/PaymentForm/DiscountCodes";

const isAdmin = (roles: string[]) => roles.includes("admin");

const InnerRoutes: MenuRoute[] = [
  {
    path: "/products/:id",
    title: "Products",
    hidden: true,
    component: ProductEditPage,
  },
  {
    path: "/products",
    title: "Products",
    icon: <Inventory2Outlined />,
    component: ProductListPage,
    resolveHidden: isAdmin,
  },
  {
    path: "/discount",
    title: "Discount codes",
    icon: <Inventory2Outlined />,
    component: DiscountCodesListPage,
    resolveHidden: isAdmin,
  },


  // {
  //   path: "/settings",
  //   title: "Settings",
  //   icon: <Settings />,
  //   component: SettingsGeneral,
  //   resolveHidden: isAdmin,
  // },

  {
    path: "/cms",
    title: "CMS",
    icon: <PrintOutlined />,
    component: CMS,
    resolveHidden: isAdmin,
  },
  {
    path: "/forms",
    title: "Forms",
    icon: <AssignmentOutlined />,
    component: Forms,
    resolveHidden: isAdmin,
  },
  {
    path: "/messages",
    title: "Messages",
    icon: <TranslateOutlined />,
    component: LocalizedMessagesX,
    resolveHidden: isAdmin,
  },

  { 
      path: '/system',
      title: 'System',
      resolveHidden: isAdmin,
      icon: <Settings />,
      component: () => (
          <SystemSubmenu
              emails={{ apiPath: "/emails" }}
              users={{ allowInvites: true, allowPaswordReset: true, allowPaswordChange: true, twoFactorAuthEnabled: true }}
              pages={[{
                  apiPath: "/api/page",
                  key: "all",
                  label: "All",
              }]}
              queryConsole={{}}
              apiTokens={{ apiPath: "/api/apitoken" }}
          />),
  },
];

export default InnerRoutes;